<template>
  <vue-resizable
    style="position: absolute; z-index: 20"
    :width="300"
    height="auto"
    :left="600"
    :top="200"
    drag-selector=".drag-handle > div"
  >
    <div class="videos">
      <div class="drag-handle">
        <div />
        <i class="bx bx-x" title="Close" @click="app.showVideo = false" />
      </div>
      <div>
        <video
          v-for="track in tracks"
          :key="track.getTrackId() + track.getTrackLabel()"
          :ref="(ref) => track && ref && track.attach(ref as HTMLVideoElement)"
          autoplay
          :class="{
            local: track.isLocal(),
            focus: track === focus,
            video: true,
            //prank: true,  Just for fun, uncomment to prank everyone by inverting their video and rotating it diagonally
          }"
        />
      </div>
    </div>
  </vue-resizable>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { getApp } from '../models/App';
import VueResizable from './vue-resizable.vue';

const app = getApp();
const tracks = computed(() =>
  app.connection.currentRoom?.tracks.filter((t) => t.getType() === 'video' && t.getVideoType() !== 'desktop'),
);

const focus = computed(() => {
  const conf = app.connection.currentRoom;

  if (!conf) return null;

  return conf.getDominantVideo() || conf.getNonLocalVideo() || conf.getLocalVideo();
});
</script>

<style scoped>
div.videos {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: white;
  box-sizing: border-box;
  border: 4px solid black;

  & > .drag-handle {
    height: 25px;
    background: var(--color-gray);
    display: flex;
    cursor: move;

    & > div {
      flex-grow: 1;
      height: 25px;
    }

    & > i {
      background: var(--color-accent-icon);
      color: white;
      cursor: pointer;
      width: 25px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      font-size: 25px;
    }
  }

  > div {
    display: flex;
    flex-wrap: wrap;
  }

  > div > video {
    min-width: 100px;
    max-width: 200px;
    flex: 1 1;
    border: none;
  }

  > div > video.local {
    transform: scaleX(-1);
  }

  > div > video.focus {
    order: -1;
    min-width: 100%;
    max-width: 100%;
  }
/*
  > div > video.prank {
      filter: invert(100%);
      animation: rotate-diagonal 3s infinite;
    }
*/
}

/*
  @keyframes rotate-diagonal {
    from {
      transform: rotate3d(1, 1, 1, 45deg);
    }
    to {
      transform: rotate3d(1, 1, 1, -45deg);
    }
  }
*/
</style>
